export const analysisLayoutStyle = {
    display: 'flex',
    gap: '12px',
    height: '100%'
};

export const analysisControlPanelStyle = {
    minWidth: '420px'
};

export const analysisCanvasPanelStyle = {
    display: 'inline',
    width: '100%',
    minHeight: '300px',
    padding: '10px',
    background: 'linear-gradient(180deg, #ffffff 0%, #f7fcfd 100%)',
    border: '1px solid #cfe3ea',
    borderRadius: '12px',
    boxShadow: '0 10px 22px rgba(7, 72, 82, 0.12)',
    overflow: 'auto' as const
};

export const analysisPanelCss = `
    @keyframes heatmapFadeUp {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
    }

    .heatmap-layout {
        animation: heatmapFadeUp 260ms ease-out both;
        padding: 10px;
    }

    .heatmap-control-panel {
        display: flex;
        flex-direction: column;
        padding: 10px;
        background: #F7F7F7;
        flex: 1.5 1 0px;
        overflow-y: auto;
        border: 1px solid #d6e8ee;
        border-radius: 14px;
        box-shadow: 0 10px 24px rgba(10, 55, 75, 0.08);
    }

    .heatmap-control-panel,
    .heatmap-canvas-panel {
        transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
    }

    .heatmap-action-btn {
        transition: transform 170ms ease, box-shadow 170ms ease, filter 170ms ease;
    }

    .heatmap-action-btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 14px rgba(8, 65, 73, 0.24);
        filter: saturate(1.05);
    }

    .heatmap-map-controls button {
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(8, 65, 73, 0.18);
    }

    .heatmap-section {
        padding: 12px 4px;
        border-bottom: 1px solid #dbe9ee;
    }

    .heatmap-section:last-child {
        border-bottom: none;
    }

    .heatmap-section-title {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #0f5f68;
        margin-bottom: 8px;
    }

    .heatmap-section-desc,
    .heatmap-hint,
    .heatmap-field-hint {
        font-size: 12px;
        font-weight: 400;
        color: #4a5b60;
        margin-top: 6px;
    }

    .heatmap-field-hint {
        margin-top: 2px;
    }

    .heatmap-field-label {
        font-size: 13px;
        font-weight: 600;
        margin: 8px 0 4px;
    }

    .heatmap-device-picker {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .heatmap-device-picker .heatmap-device-select {
        flex: 1 1 auto;
        min-width: 0;
    }

    .heatmap-popup-toggle {
        justify-content: space-between;
        padding: 2px 0 6px;
        margin-bottom: 4px;
        border-bottom: 1px solid #eef4f6;
        font-size: 12px;
    }

    .heatmap-inline-field {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .heatmap-switch-row {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 20px;
        margin-top: 10px;
    }

    .heatmap-type-group {
        display: flex;
        width: 100%;
    }

    .heatmap-type-group .k-button {
        flex: 1 1 0;
    }

    .heatmap-type-group .k-button.k-selected {
        background: #198692;
        border-color: #198692;
        color: #fff;
    }

    .heatmap-analyze-btn {
        width: 100%;
        padding: 10px;
        font-weight: 600;
        background: #198692;
        border-color: #198692;
        color: #fff;
    }

    .heatmap-device-select .k-chip {
        background: #198692;
        border-color: #198692;
        color: #fff;
    }

    .heatmap-select-all {
        padding: 6px 10px;
        border-bottom: 1px solid #dbe9ee;
    }

    .heatmap-select-all-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        padding: 4px 0;
        border: none;
        background: none;
        font-weight: 600;
        color: #0f5f68;
        cursor: pointer;
        text-align: left;
    }

    .heatmap-select-all-btn:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    .heatmap-select-all-btn:focus-visible {
        outline: 2px solid #198692;
        outline-offset: 2px;
    }

    .heatmap-device-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
    }

    .heatmap-device-name {
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .heatmap-device-mac {
        margin-left: auto;
        color: #4a5b60;
        font-family: monospace;
    }

    .heatmap-device-footer {
        padding: 6px 10px;
        font-size: 12px;
        color: #4a5b60;
        border-top: 1px solid #dbe9ee;
    }

    .heatmap-layout .k-multiselect {
        border: 1px solid #b8d5dc;
        border-radius: 10px;
        background: #fbfeff;
    }

    @media (max-width: 1100px) {
        .heatmap-layout {
            flex-direction: column;
        }

        .heatmap-control-panel {
            min-width: 100% !important;
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .heatmap-layout,
        .heatmap-control-panel,
        .heatmap-canvas-panel,
        .heatmap-action-btn {
            animation: none !important;
            transition: none !important;
        }
    }
`;
